import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule, MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {NgIf, NgFor, AsyncPipe} from "@angular/common";
import {Observable, Subscription} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {User} from "../../model/user";
import {AdminService} from "../../services/admin.service";

@Component({
  selector: 'app-user-picker',
  templateUrl: './user-picker.component.html',
  styleUrls: ['./user-picker.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    NgIf,
    NgFor,
    AsyncPipe
  ]
})
export class UserPickerComponent implements OnInit, OnDestroy {

  @Input() label = 'Select user';
  @Output() userSelected = new EventEmitter<User>();

  searchControl = new FormControl('');
  filteredUsers$: Observable<User[]>;

  private users: User[] = [];
  private usersSub: Subscription;

  constructor(private adminService: AdminService) { }

  ngOnInit(): void {
    this.usersSub = this.adminService.getAllOwners().subscribe(users => {
      this.users = [...users].sort((a, b) =>
        this.displayLabel(a).localeCompare(this.displayLabel(b)));
    });
    this.filteredUsers$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filter(typeof value === 'string' ? value : ''))
    );
  }

  displayLabel(user: User): string {
    return user?.displayName || user?.email || '';
  }

  onSelected(event: MatAutocompleteSelectedEvent): void {
    this.userSelected.emit(event.option.value as User);
  }

  display = (user: User): string => this.displayLabel(user);

  private filter(term: string): User[] {
    const needle = term.toLowerCase().trim();
    if (!needle) {
      return this.users;
    }
    return this.users.filter(u =>
      (u.displayName || '').toLowerCase().includes(needle) ||
      (u.email || '').toLowerCase().includes(needle));
  }

  ngOnDestroy(): void {
    this.usersSub?.unsubscribe();
  }
}
